module.exports = __webpack_public_path__ + "img/ORG20210823_114632.33458e5f.jpg";